import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useLanguage } from "../i18n/LanguageContext";

const LOGIN_URL = "https://app.ticket-box.fr";

function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const { t, locale, setLocale } = useLanguage();

  const closeMenu = () => setMenuOpen(false);

  return (
    <header className={`nav ${menuOpen ? "nav-open" : ""}`}>
      <Link to="/" className="brand" onClick={closeMenu}>
        <img className="brand-logo" src="/assets/icon.png" alt="TicketBox" />
        <span>TicketBox</span>
      </Link>

      <button
        className="nav-toggle"
        type="button"
        aria-label="Menu"
        aria-expanded={menuOpen}
        onClick={() => setMenuOpen((open) => !open)}
      >
        <span />
        <span />
        <span />
      </button>

      <nav className="nav-links">
        <a href="/#features" onClick={closeMenu}>
          {t.nav.features}
        </a>
        <a href="/#workflow" onClick={closeMenu}>
          {t.nav.howItWorks}
        </a>
        <a href="/#dashboard" onClick={closeMenu}>
          {t.nav.dashboard}
        </a>
        <a href="/#download" className="btn btn-dark" onClick={closeMenu}>
          {t.nav.download}
        </a>
        <a href={LOGIN_URL} className="btn btn-light nav-login">
          {t.nav.login}
        </a>
        <div className="lang-toggle" role="group" aria-label="Language">
          <button
            type="button"
            className={`lang-pill${locale === "en" ? " active" : ""}`}
            onClick={() => setLocale("en")}
          >
            EN
          </button>
          <button
            type="button"
            className={`lang-pill${locale === "fr" ? " active" : ""}`}
            onClick={() => setLocale("fr")}
          >
            FR
          </button>
        </div>
      </nav>
    </header>
  );
}

export default Header;
